// Module
var code = "<p>Choose a unique color palette to help create a branded experience.</p> <p>Changing color palettes affects the colors of your survey.</p> ";
// Exports
module.exports = code;